import Grid from '@mui/joy/Grid'
import { Card, CardContent, Container, Skeleton } from '@mui/joy'
import React from 'react'

function StoreLoading() {
  return (
    <Grid sx={{ pb: 2 }}>
      <Grid>
        <Card size="sm">
          <CardContent>
            <Container
              maxWidth="sm"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Skeleton variant="rectangular" width={300} height={200} />
              <Skeleton sx={{ mt: 2 }} variant="text" width={300} height={20} />
              <Skeleton variant="text" width={300} height={20} />
            </Container>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

export default StoreLoading
